import {
  AudioManager,
  useActivityIndicator,
  PlayIcon,
  PauseIcon,
  HideFor,
  breakpoints,
  IconButton,
} from "@pm2/compat";
import { Progressbar } from "./atom.progress-bar";
import * as styles from "./molecule.controls.style";
import { formatTime } from "./util.format-time";

type Props = {
  audio: AudioManager;
  disabled: boolean;
};

export function Controls(props: Props) {
  const isLoading = useActivityIndicator(props.audio.isLoading, {
    delayMs: 1000,
  });

  const icon = (() => {
    if (isLoading.isActive()) {
      return { key: "loader", element: <span className={styles.loader} /> };
    }

    if (!props.audio.isPlaying) {
      return {
        key: "play",
        element: <PlayIcon height={16} fill="none" stroke="currentColor" />,
      };
    } else {
      return {
        key: "pause",
        element: <PauseIcon height={16} />,
      };
    }
  })();

  const onClick = () => {
    if (props.audio.isLoading || props.audio.isPlaying) {
      props.audio.pause();
    } else {
      props.audio.resume();
    }
  };

  const progress =
    (props.audio.timeElapsedMs ?? 0) / (props.audio.durationMs ?? 1);

  return (
    <div className={styles.wrapper}>
      {!props.audio.didError && (
        <HideFor breakpoint={breakpoints.mobile}>
          <IconButton
            className={styles.iconButton}
            icon={icon.element}
            iconKey={icon.key}
            size="small"
            label={
              props.disabled
                ? "Log på for at høre lydklippet"
                : props.audio.isPlaying || props.audio.isLoading
                ? "Pause"
                : "Start afspilning af lydfil"
            }
            onClick={onClick}
            disabled={props.disabled}
          />
        </HideFor>
      )}

      <Progressbar
        isPlaying={props.audio.isPlaying || props.audio.isLoading}
        durationMs={props.audio.durationMs ?? 0}
        progress={progress}
        resume={props.audio.resume}
        pause={props.audio.pause}
        seek={props.audio.seek}
        disabled={props.disabled || props.audio.didError}
      />

      <span className={styles.progressText}>
        <span>{formatTime(props.audio.timeElapsedMs || 0)} </span>

        <span>{formatTime(props.audio.durationMs || 0)}</span>
      </span>
    </div>
  );
}
